import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import MainButton from '../../buttons/MainButton';
import classes from './MaxAlertsQTYPopUp.module.scss';
import { useWindowSize } from '../../../../utils/hooks';
import { responsiveSizeJobs } from '../../../../utils/constants';

const MaxAlertsQTYPopUp = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { width } = useWindowSize();

  return (
    <div className={classes.popupContainer}>
      <p className={classes.popupLabel}>{t('dashboard.settings.maxalertsmodal.label')}</p>
      <div className={classes.infoTextContainer}>
        <p className={classes.popupInfoTxt}>{t('dashboard.settings.maxalertsmodal.text')}</p>
      </div>
      <MainButton
        size={width > responsiveSizeJobs ? 'xmedium' : 'small'}
        rounded
        forceWidth={width > responsiveSizeJobs ? '326px' : '100%'}
        action={() => navigate('/dashboard/settings?tab=emailnotifications')}
      >
        {t('dashboard.settings.maxalertsmodal.button')}
      </MainButton>
    </div>
  );
};

export default MaxAlertsQTYPopUp;
